import { IConfig } from "Config";
var config: IConfig = {
    BASE_API_URL: window.location.origin,
    BASE_URL: '/Themes/EInvoice/Mobile/'
};

export default config;
